<template>
  <div class="tk-skeleton" v-bind="$attrs" :style="skeletonStyle">&nbsp;</div>
</template>

<script>
// #ffe6e6, e6e6e6
// #DDDBDD, #f0f2f5
export const DEFAULT_BACKGROUND = '#e6e6e6'

export default {
  name: 'TkSkeletonLoader',
  props: {
    color: {
      type: String,
      default: DEFAULT_BACKGROUND,
    },
    duration: {
      type: Number,
      default: 1.8,
    },
  },
  computed: {
    skeletonStyle() {
      return {
        backgroundColor: this.color,
        backgroundImage: `linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 63%,
          rgba(255, 255, 255, 0)
        )`,
        animation: `bgpos ${this.duration}s ease-in-out infinite`,
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkSkeletonLoader.scss';
</style>
